import { Box, BoxProps, styled, useTheme } from '@mui/material'
import React from 'react'
import { DynamicTextTypography } from 'src/components/DynamicTextTypography'
import { MUIThemeColors } from 'src/mui-theme'
import { getThemeColor } from 'src/utils'

interface StyledDrawingBoxProps extends BoxProps {
  height?: string
  maxWidth?: string
  bottomMargin?: string
}

interface PositionDrawingNumberBox extends StyledDrawingBoxProps {
  selectedDrawingNumber: string
  fontSize?: string
  maxLength?: number
}

const PositionDrawingNumberBox: React.FC<PositionDrawingNumberBox> = ({ selectedDrawingNumber, height, maxWidth, fontSize, maxLength, bottomMargin }) => {
  const theme = useTheme()
  return (
    <StyledDrawingNumberBox maxWidth={maxWidth ?? '350px'} height={height} alignContent={'center'} justifyContent={'center'} bottomMargin={bottomMargin}>
      <DynamicTextTypography
        text={selectedDrawingNumber}
        maxLength={maxLength ?? 25}
        fontSize={fontSize ?? '20px'}
        color={getThemeColor(theme, MUIThemeColors.white)}
      />
    </StyledDrawingNumberBox>
  )
}

export default PositionDrawingNumberBox

export const StyledDrawingNumberBox = styled(Box)<StyledDrawingBoxProps>(({ theme, height, maxWidth,bottomMargin }) => ({
  position: 'absolute',
  bottom: 0,
  right: 0,
  marginBottom: bottomMargin ?? '20px',
  marginRight: '1px',
  backgroundColor: theme.palette.primaryMain[theme.palette.mode],
  padding: '4px',
  height: height ?? 'auto',
  maxWidth: maxWidth ?? 'auto',
}))
